import React from "react";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import PublicOutlinedIcon from "@mui/icons-material/PublicOutlined";
import DialpadIcon from "@mui/icons-material/Dialpad";
import MoneyOutlinedIcon from "@mui/icons-material/MoneyOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";

export default function PmCodeIcon({ pmCode, ...props }) {
  const code = String(pmCode || "").toLowerCase();

  switch (code) {
    case "cp":
      return <PointOfSaleOutlinedIcon {...props} />;
    case "cnp":
      return <PublicOutlinedIcon {...props} />;
    case "moto":
      return <DialpadIcon {...props} />;
    case "cash":
      return <MoneyOutlinedIcon {...props} />;
    case "check":
      return <DriveFileRenameOutlineIcon {...props} />;
    case "standalone_terminal":
      return <PaymentsOutlinedIcon {...props} />;
    case "gift_card":
      return <CardGiftcardIcon {...props} />;
    default:
      return <CreditCardOutlinedIcon {...props} />;
  }
}
